/**
 * !(i)
 * The code is included in the final file only when a function is called, for example: FLSFunctions.spollers();
 * Or when the entire file is imported, for example: import 'files/script.js';
 * Unused code does not end up in the final file.

 * If we want to add a module, we should uncomment it.
 */

// support webp, identify device
import BaseHelpers from "./helpers/BaseHelpers.js";
import Swiper from "swiper";
import {Autoplay, FreeMode, Navigation, Pagination, Parallax,} from "swiper/modules";
import scrollButter from 'scroll-butter';
import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Lenis from 'lenis'
import {
  IS_LARGE_PC,
  IS_MOBILE,
  IS_PC,
  IS_SMALL_SIZE,
  IS_TABLET,
  parallaxScaleSize
} from "./helpers/screenSize";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

BaseHelpers.checkWebpSupport();
BaseHelpers.addTouchClass();
BaseHelpers.addLoadedClass();

window.addEventListener("beforeunload", function () {
  setTimeout(() => {
    window.scrollTo(0, 0); // Прокручиваем страницу в начало
  }, 0);
});

BaseHelpers.setupCurrentYear(document.querySelector('.cta-section_year'));

document.addEventListener("DOMContentLoaded", () => {
  const lenis = new Lenis();

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(10000);

  function throttle(func, ms) {
    let isThrottled = false,
      savedArgs,
      savedThis;

    function wrapper() {
      if (isThrottled) {
        savedArgs = arguments;
        savedThis = this;
        return;
      }

      func.apply(this, arguments);

      isThrottled = true;

      setTimeout(function () {
        isThrottled = false;
        if (savedArgs) {
          wrapper.apply(savedThis, savedArgs);
          savedArgs = savedThis = null;
        }
      }, ms);
    }

    return wrapper;
  }

  scrollButter.init({
    wrapperId: 'page',
    wrapperDamper: 0.02,
    cancelOnTouch: true
  });

  const consentBox = document.getElementById("box-cookie");
  const acceptBtn = document.querySelector(".box-cookie__consentButton");
  const closeBtn = document.querySelector(".js-cookie-btn-close");

  // Обработчик для кнопки "Принять всё"
  acceptBtn.onclick = () => {
    document.cookie = "CookieBy=GeeksForGeeks; max-age=" + 60 * 60 * 24 * 7;
    consentBox.classList.add("hide");
  };

  // Обработчик для кнопки "Закрыть"
  closeBtn.onclick = () => {
    consentBox.classList.add("hide");
  };

  // Проверяем наличие куки при загрузке страницы
  let checkCookie = document.cookie.indexOf("CookieBy=GeeksForGeeks");
  checkCookie !== -1
    ? consentBox.classList.add("hide")
    : consentBox.classList.remove("hide");

  // Показываем блок с задержкой
  setTimeout(() => {
    consentBox.style.display = "block";
  }, 2000);

  function changingPictureHeroSection(){
    const imgContainer = document.querySelector('.hero-section__img-container');
    const image = document.querySelector(".js-hero-img");
    let imgChanged = false;

    function updateImageVisibility() {

      // Количество px окна браузера разделенное на 4
      const quarterViewport = window.innerHeight / 4;

      // Верхняя точка изображения
      const topPointImgContainer = imgContainer.getBoundingClientRect().top;

      const isChangeImg = topPointImgContainer < quarterViewport;
      const isNotVisible = topPointImgContainer >= quarterViewport;

      // Изображение уже не видно
      if (isChangeImg && imgChanged && !isNotVisible) return;

      // Вернулись к изображению после скролла
      if (!isChangeImg && imgChanged && isNotVisible) {
        image.classList.toggle("hero-section__img_hide");
        imgChanged = false;
      }

      // Изображение проскроллили
      if (isChangeImg && !isNotVisible) {
        image.classList.toggle("hero-section__img_hide");
        imgChanged = true;
      }
    }

    function wrapperThrottle() {
      throttle(updateImageVisibility(), 350)
    }

    window.addEventListener("scroll", () => wrapperThrottle());
  }

  try {
    changingPictureHeroSection();
  } catch (error) {
    console.error(error);
    throw new Error("Ошибка в навигации");
  }

  const handleStickyHeader = () => {
    const headerTargetPoint1 = document.querySelector(
      ".js-header-sticky-point-1"
    );
    const headerTargetPoint2 = document.querySelector(
      ".js-header-sticky-point-2"
    );
    const headerSticky = document.querySelector(".js-header-sticky");
    let isVisible = true; // Видно хэдер
    let isDisplay = false; // Нужно отображать?

    if (headerTargetPoint1 && headerTargetPoint2) {
      const checkSticky = () => {
        const sectionTop1 =
          headerTargetPoint1.getBoundingClientRect().top + window.scrollY;
        const sectionTop2 =
          headerTargetPoint2.getBoundingClientRect().top + window.scrollY;
        const isSticky1 = window.scrollY > sectionTop1;
        const isSticky2 = window.scrollY > sectionTop2;

        headerSticky.classList.toggle("is-sticky-scroll", isSticky1);
        headerSticky.classList.toggle("is-sticky-point", isSticky2);

        const headerStickyScroll = headerSticky.classList.contains('is-sticky-scroll');
        const headerStickyPoint = headerSticky.classList.contains('is-sticky-point');

        // Поднять хэдер и скрыть его (в самом начале страницы)
        if(headerStickyScroll && !headerStickyPoint && isVisible && !isDisplay && headerSticky.style.opacity === "1") {
          isVisible = false;
          isDisplay = true;
          gsap
          .fromTo(
            headerSticky,
            {
              opacity:1,
              y: 100,
            },
            {
              duration: 0,
              opacity: 0,
              y: 0,
            }
          )
        }

        // Хэдер скатывается вниз
        if (headerStickyScroll && headerStickyPoint && !isVisible && isDisplay) {
          isVisible = true;
          isDisplay = false;

          if (headerSticky.style.opacity === '0.01') {
            return false;
          }

          gsap
            .fromTo(
              headerSticky,
              {
                opacity: 0 ,
                y: 0,
              },
              {
                scrollTrigger: {
                  trigger: ".js-header-sticky-point-2",
                  start: 'top top',
                  end: IS_MOBILE ? '+=110vw' : '+=250',
                  scrub: true,
                },
                ease: 'none',
                duration: 2,
                opacity: 1,
                y: IS_MOBILE ? '26vw' : 100,
              }
            )
        }

        // Поставить хэдер на место и показать его (после scrollTrigger)
        if (!headerStickyScroll && !headerStickyPoint && isVisible && !isDisplay && headerSticky.style.opacity === "0") {
          isVisible = true;
          isDisplay = false;
          gsap
          .fromTo(
            headerSticky,
            {
              opacity:0,
            },
            {
              duration: 0.5,
              opacity: 1,
            }
          )
        }

        // Спуск до первой секции и подъем обратно
        if (!headerStickyScroll && !headerStickyPoint && !isVisible && isDisplay && headerSticky.style.opacity === "0") {
          isVisible = true;
          isDisplay = false;
          gsap
          .fromTo(
            headerSticky,
            {
              opacity:0,
            },
            {
              duration: 0.5,
              opacity: 1,
            }
          )
        }

        // Отображение хэдера при загрузке страницы за пределами секции .hero-section
        if (headerStickyScroll && headerStickyPoint && isVisible && !isDisplay && headerSticky.style.transform === '') {
          isVisible = false;
          isDisplay = true;
        }
      };

      let isScrollEventFired = false;

      const fireCustomScrollEvent = () => {
        if (!isScrollEventFired && window.scrollY === 0) {
          const scrollEvent = new Event("scroll");
          window.dispatchEvent(scrollEvent);
          isScrollEventFired = true;
        } else {
          isScrollEventFired = false;
        }
      };

      const handleScroll = () => {
        checkSticky();
        fireCustomScrollEvent();
        requestAnimationFrame(wrapperThrottle);
      };

      function wrapperThrottle() {
        throttle(handleScroll(), 350)
      }

      handleScroll();
    } else {
      console.error("Header target points not found.");
    }
  };

  handleStickyHeader();
  const whiteSpans = document.querySelectorAll('.features-section__title-white');
  const greenSpan = document.querySelector('.features-section__title_green');
  const whiteSpans1 = document.querySelectorAll('.features-section__title-white-1');

  whiteSpans.forEach((span) => BaseHelpers.splitText(span));
  whiteSpans1.forEach((span) => BaseHelpers.splitText(span));
  BaseHelpers.splitText(greenSpan);

  const whiteLetters = document.querySelectorAll('.features-section__title-white span');
  const greenLetters = greenSpan.querySelectorAll('span');
  const whiteLetters1 = document.querySelectorAll('.features-section__title-white-1 span');

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.features-section',
      start: 'top top',
      end: '+=100%',
      scrub: true,
      pin: true
    },
  });

  timeline.to(
      whiteLetters,
      {
        color: '#fff',
        stagger: 0.05,
        ease: 'none',
      },
      0
  );

  timeline.to(
      greenLetters,
      {
        color: '#00ff00',
        stagger: 0.05,
        ease: 'none',
      },
      '>+0.2'
  );

  timeline.to(
      whiteLetters1,
      {
        color: '#fff',
        stagger: 0.05,
        ease: 'none',
      },
      '>+0.2'
  );
});

function hoverLogoOn(element) {
  element.querySelector('.clients-card--cech-logo-default').style.display = 'none';
  element.querySelector('.clients-card--cech-logo-hover').style.display = 'block';
  element.querySelector('.clients-card--cech-links').style.opacity = '1';
  element.querySelector('.clients-card--cech-links').style.visibility = 'visible';
  element.querySelector('.clients-card--cech-links').style.pointerEvents = 'auto';
}

function hoverLogoOff(element) {
  element.querySelector('.clients-card--cech-logo-default').style.display = 'block';
  element.querySelector('.clients-card--cech-logo-hover').style.display = 'none';
  element.querySelector('.clients-card--cech-links').style.opacity = '0';
  element.querySelector('.clients-card--cech-links').style.visibility = 'hidden';
  element.querySelector('.clients-card--cech-links').style.pointerEvents = 'none';
}

document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.clients-card--cech');

  cards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      hoverLogoOn(this);
    });

    card.addEventListener('mouseleave', function() {
      hoverLogoOff(this);
    });
  });
});

  const scrollNavigationControl = () => {
    const sections = document.querySelectorAll(".js-section");
    const navLinks = document.querySelectorAll(".js-link-anchor");
    const navList = document.querySelector(".header__nav-list");
    const navDot = document.querySelector(".header__nav-dot");
    const btnLinks = document.querySelectorAll(".js-link-anchor-btn");
    const ctaSection = document.querySelector(".cta-section");
    let currentActiveSection = null;

    function setActiveLink() {
      // Если видно секцию, то возвращает эту секцию
      function getVisibleSection() {
        let activeSection;

        sections.forEach((section) => {
          const positionSection = section.getBoundingClientRect();
          const sectionVisible =
              positionSection.top <= window.innerHeight / 2 &&
              positionSection.bottom >= window.innerHeight / 2;

          if (sectionVisible) {
            activeSection = section;
          }
        });

        return activeSection;
      }

      const sectionIsVisible = getVisibleSection();
      /**
       * Если пользователь
       * находится в
       * header или footer
       */
      if (currentActiveSection === sectionIsVisible) {
        return false;
      }

      /**
       * Если пользователь
       * доскроллил до footer
       * или поднялся до header
       */

      if (currentActiveSection?.id && !sectionIsVisible) {
        BaseHelpers.removeClass([...navLinks], 'active');
        BaseHelpers.removeClass(navList, 'is-active', currentActiveSection.id);
        currentActiveSection = null;
        return false;
      }

      /**
       * Пользователь проскроллил
       * на следующую секцию
       * после header
       */
      if (!currentActiveSection) {
        currentActiveSection = sectionIsVisible;
      }

      /**
       * Скролл по отслеживаемым секциям
       */
      if (sectionIsVisible !== currentActiveSection && currentActiveSection.id) {
        BaseHelpers.removeClass([...navLinks], 'active');
        BaseHelpers.removeClass(navList, 'is-active', currentActiveSection.id)
        currentActiveSection = sectionIsVisible
      }

      if (sectionIsVisible?.id) {
        BaseHelpers.writeClass([...navLinks], 'active', sectionIsVisible?.id);
        BaseHelpers.writeClass(navList, 'is-active', sectionIsVisible?.id);
      }

      updateNavDotPosition();
    }

    function throttle(func, ms) {
      let isThrottled = false,
          savedArgs,
          savedThis;

      function wrapper() {
        if (isThrottled) {
          savedArgs = arguments;
          savedThis = this;
          return;
        }

        func.apply(this, arguments);

        isThrottled = true;

        setTimeout(function () {
          isThrottled = false;
          if (savedArgs) {
            wrapper.apply(savedThis, savedArgs);
            savedArgs = savedThis = null;
          }
        }, ms);
      }

      return wrapper;
    }

    function wrapperThrottle() {
     throttle(setActiveLink(), 350)
    }

    window.addEventListener("scroll", () => wrapperThrottle());

    const updateNavDotPosition = () => {
      const activeLink = navList.querySelector(".js-link-anchor.active");

      if (!activeLink) {
        return false;
      }

      const activeLinkRect = activeLink.getBoundingClientRect();
      const navDotX = Math.round(
        activeLinkRect.left +
          activeLinkRect.width / 2 -
          navList.getBoundingClientRect().left
      );
      const navDotY = Math.round(activeLinkRect.height / 5);
      gsap.to(navDot, {
        duration: 0,
        x: navDotX,
        y: navDotY,
        ease: "power2.inOut",
      });
    };

    window.addEventListener("resize", updateNavDotPosition);

    setActiveLink();

    function addEventsListElement(listElement, position, targetElement){
      listElement.forEach((anchor) =>
        anchor.addEventListener("click", (event) => {
          event.preventDefault();
          let targetElem = targetElement;
          if (!targetElement) targetElem = getTargetSection(event.target, "js-link-anchor");
          BaseHelpers.scrollToSection(targetElem, position);
        })
      );
    }

    addEventsListElement(navLinks, 'start');
    if (IS_MOBILE) {
      addEventsListElement(btnLinks, 'start', ctaSection);
    } else {
      addEventsListElement(btnLinks, 'end', ctaSection);
    }

    function getTargetSection(element, className) {
      const targetLink = element.closest(`.${className}`);
      const targetId = targetLink.getAttribute("href").substring(1);
      return document.getElementById(targetId);
    }
  };

  try {
    scrollNavigationControl();
  } catch (error) {
    console.error(error);
    throw new Error("Ошибка в навигации");
  }

  // range slider init

  const swiper = new Swiper(".cases-section__swiper", {
    // Optional parameters
    modules: [Pagination, Navigation],
    allowTouchMove: false,
    direction: "horizontal",
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1100: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },

    // If we need pagination
    pagination: {
      el: ".cases-section-pagination",
    },
    navigation: {
      prevEl: ".cases-section-button-prev",
    },
    on: {
      init: function () {
        // Проверяем, существует ли пагинация и ее точки
        if (this.pagination && this.pagination.bullets) {
          let bullets = this.pagination.bullets;

          // Устанавливаем активные точки в соответствии с текущим слайдом
          for (let i = 0; i < this.params.slidesPerView; i++) {
            if (bullets[i]) {
              bullets[i].classList.add("swiper-pagination-bullet-active");
            }
          }
        }
      },
      slideChange: function () {
        // Проверяем, существует ли пагинация и ее точки
        if (this.pagination && this.pagination.bullets) {
        // Сбрасываем все точки пагинации
          for (let i = 0; i < this.pagination.bullets.length; i++) {
            if (this.pagination.bullets[i]) {
              this.pagination.bullets[i].classList.remove(
                "swiper-pagination-bullet-active"
              );
            }
          }

          // Устанавливаем активные точки в соответствии с текущим слайдом
          for (let i = 0; i < this.params.slidesPerView; i++) {
            if (this.pagination.bullets[this.activeIndex + i]) {
              this.pagination.bullets[this.activeIndex + i].classList.add(
                "swiper-pagination-bullet-active"
              );
            }
          }
        }
      },
    },
  });

  if (IS_MOBILE) {
    // Переключение слайдов в мобильной версии по тачу
    const casesSlider = document.querySelectorAll(".cases-slider__card-picture");
    BaseHelpers.changeSlider(casesSlider, 'touchstart', swiper);
    // Переключение слайдов в мобильной версии по клику
    BaseHelpers.changeSlider(casesSlider, 'click', swiper);
    // Переключение слайдов в мобильной версии по свайпу
    BaseHelpers.changeSlider(casesSlider, 'touchmove', swiper);
  }

  document
    .querySelector(".cases-section-button-next")
    .addEventListener("click", function () {
      if (
        window.innerWidth > 1100 &&
        swiper.activeIndex < swiper.slides.length - 3
      ) {
        BaseHelpers.removePrevSlider(swiper).then();
      }

      if (
        window.innerWidth < 1100 &&
        window.innerWidth > 768 &&
        swiper.activeIndex < swiper.slides.length - 2
      ) {
        BaseHelpers.removePrevSlider(swiper).then();
      }

      if (
        window.innerWidth < 768 &&
        swiper.activeIndex < swiper.slides.length - 1
      ) {
        BaseHelpers.removePrevSlider(swiper).then();
      }
    });

  // Выбор темы
  let lightTheme = document.getElementById("light-theme");
  let darkTheme = document.getElementById("dark-theme");
  let phoneText = document.querySelector(".phone__text");
  let phoneText2 = document.querySelector(".phone__text-2");
  let phoneText3 = document.querySelectorAll(".phone__text-3");
  let phoneCoins = document.querySelector(".phone__coins");
  let phoneBtn = document.querySelectorAll(".phone__btn");
  let phoneBtns = document.querySelector(".phone__buttons");
  let phoneCards = document.querySelector(".phone__cards");
  let phoneCells = document.querySelector(".phone__cells");
  let customSelectTrigger = document.querySelector(".custom-select-trigger");
  let customOptions = document.querySelector(".custom-options");
  let customSelect = document.querySelector(".custom-select");

  lightTheme.addEventListener("click", function () {
    handleLightTheme();
  });

  function handleLightTheme() {
    lightTheme.classList.add("create__btn_active");
    darkTheme.classList.remove("create__btn_active");

    createBlock.style.backgroundColor = "#fff";
    icons.forEach(function (icon) {
      icon.style.fill = "#000";
    });
    iconBlock.style.fill = "#fff";
    phoneText.style.color = "#000";
    phoneText2.style.color = "#000";
    phoneBtns.style.backgroundColor = "#fff";
    phoneBtns.style.borderColor = "#EDEDED";
    phoneBtn.forEach(function (item) {
      item.style.color = "#000";
    });
    phoneText3.forEach(function (item) {
      item.style.color = "#000";
    });

    BaseHelpers.removeActiveClass(colorPalette);
  }

  darkTheme.addEventListener("click", function () {
    handleDarkTheme();
  });

  function handleDarkTheme() {
    darkTheme.classList.add("create__btn_active");
    lightTheme.classList.remove("create__btn_active");
    createBlock.style.backgroundColor = "#0B0B0B";
    icons.forEach(function (icon) {
      icon.style.fill = "#0B0B0B";
    });

    document.querySelector(".phone__coins path").style.fill = "#fff";
    phoneCoins.style.cssText = `
    background: #000;
    border-color: #636363;
    color:#fff;
  `;
    iconBlock.style.fill = "#636363";
    phoneText.style.color = "#fff";
    phoneText2.style.color = "#fff";
    phoneBtns.style.backgroundColor = "#0B0B0B";
    phoneBtns.style.borderColor = "#202020";
    phoneBtn.forEach(function (item) {
      item.style.color = "#fff";
    });
    phoneText3.forEach(function (item) {
      item.style.color = "#fff";
    });

    BaseHelpers.removeActiveClass(colorPalette);
  }

  // Выбор шрифта

  customSelectTrigger.addEventListener("click", function () {
    customSelectTrigger.classList.toggle("open");
    customOptions.classList.toggle("open");
    customSelect.classList.toggle("open");
  });

  document.querySelectorAll(".custom-option").forEach(function (option) {
    option.addEventListener("click", function () {
      customSelectTrigger.textContent = this.textContent;
      customOptions.classList.remove("open");
      customSelectTrigger.classList.remove("open");
      customSelect.classList.remove("open");

      // Получаем выбранное значение
      let selectedFont = this.getAttribute("data-value");

      // Изменяем шрифт элементов
      phoneText.style.fontFamily = selectedFont;
      phoneText2.style.fontFamily = selectedFont;
      phoneText3.forEach(function (item) {
        item.style.fontFamily = selectedFont;
      });
      phoneCoins.style.fontFamily = selectedFont;
      phoneBtns.style.fontFamily = selectedFont;
      phoneCards.style.fontFamily = selectedFont;
      phoneCells.style.fontFamily = selectedFont;
    });
  });

  document.addEventListener("click", function (e) {
    if (
      !customSelectTrigger.contains(e.target) &&
      !customOptions.contains(e.target)
    ) {
      customOptions.classList.remove("open");
      customSelectTrigger.classList.remove("open");
      customSelect.classList.remove("open");
    }
  });

  //Расположение карточек

  let gridBtn = document.getElementById("grid");
  let listBtn = document.getElementById("list");
  let phoneCard3 = document.querySelectorAll(".phone__card-3");
  let phoneCell = document.querySelectorAll(".phone__cell");
  let phoneMenu = document.querySelector(".phone__menu");
  let createBtnSvg = document.querySelectorAll(".create__btn-svg path");
  let createBtnSvg2 = document.querySelectorAll(".create__btn-svg-2 path");

  gridBtn.addEventListener("click", function () {
    gridBtn.classList.add("create__btn_active");
    listBtn.classList.remove("create__btn_active");
    createBtnSvg.forEach(function (svg) {
      svg.style.fill = "#0B0B0B";
    });
    createBtnSvg2.forEach(function (svg2) {
      svg2.style.fill = "#CDCDCD";
    });
    phoneCells.style.flexDirection = "";
    phoneCells.style.alignItems = "";
    createBlock.style.overflow = "";
    phoneCells.style.maxWidth = "";
    phoneImgs.forEach(function (imgCell) {
      imgCell.style.maxWidth = "";
    });
    phoneCard3.forEach(function (card3) {
      card3.style.width = "";
      card3.style.backgroundColor = "";
      card3.style.textAlign = "";
      card3.style.borderRadius = "";
    });
    phoneMenu.style.position = "";
    phoneMenu.style.bottom = "";
    phoneCell.forEach(function (cell) {
      cell.style.maxWidth = "";
      cell.style.width = "";
    });
  });

  listBtn.addEventListener("click", function () {
    listBtn.classList.add("create__btn_active");
    gridBtn.classList.remove("create__btn_active");
    createBtnSvg.forEach(function (svg) {
      svg.style.fill = "#CDCDCD";
    });
    createBtnSvg2.forEach(function (svg2) {
      svg2.style.fill = "#0B0B0B";
    });
    phoneImgs.forEach(function (imgCell) {
      imgCell.style.maxWidth = "108px";
    });
    phoneCells.style.flexDirection = "column";
    phoneCells.style.alignItems = "center";
    createBlock.style.overflow = "hidden";
    phoneCells.style.maxWidth = "unset";

    phoneCard3.forEach(function (card3) {
      card3.style.width = "100%";
      card3.style.backgroundColor = "#f8f5f3";
      card3.style.textAlign = "center";
      card3.style.borderRadius = "12px";
    });
    phoneCell.forEach(function (cell) {
      cell.style.maxWidth = "unset";
      cell.style.width = "100%";
    });
  });

  //Выбор цвета

  let white = document.getElementById("white");
  let gray = document.getElementById("gray");
  let orange = document.getElementById("orange");
  let blue = document.getElementById("blue");
  let purple = document.getElementById("purple");
  let icons = document.querySelectorAll(".path-svg");
  let iconBlock = document.querySelector(".path-svg-block");

  let createBlock = document.querySelector(".phone__main-content");

  const colorPalette = [white, gray, orange, blue, purple];

  white.addEventListener("click", function () {
    if (darkTheme.classList.contains("create__btn_active")) {
      createBlock.style.backgroundColor = "#fff";
      icons.forEach(function (icon) {
        icon.style.fill = "#000";
      });
      iconBlock.style.fill = "#fff";
      phoneText.style.color = "#000";
      phoneText2.style.color = "#000";
      phoneBtns.style.backgroundColor = "#636363";
      phoneBtns.style.borderColor = "#EDEDED";
      phoneBtnActive.style.background = "#0B0B0B";
      phoneBtn.forEach(function (item) {
        item.style.color = "#fff";
      });
      phoneText3.forEach(function (item) {
        item.style.color = "#000";
      });
    } else {
      phoneBtnActive.style.background = "#636363";
    }

    createBlock.style.backgroundColor = "#fff";
    icons.forEach(function (icon) {
      icon.style.fill = "#fff";
    });
    iconBlock.style.fill = "#000";
    BaseHelpers.removeActiveClass(colorPalette);
    white.classList.add("create__color-btn_active");
  });

  gray.addEventListener("click", function () {
    if (darkTheme.classList.contains("create__btn_active")) {
      iconBlock.style.fill = "#000";
      phoneBtns.style.borderColor = "none";
    } else {
      iconBlock.style.fill = "#fff";
    }

    createBlock.style.backgroundColor = "#D0CDC0";
    icons.forEach(function (icon) {
      icon.style.fill = "#D0CDC0";
    });
    BaseHelpers.removeActiveClass(colorPalette);
    gray.classList.add("create__color-btn_active");
  });

  orange.addEventListener("click", function () {
    if (darkTheme.classList.contains("create__btn_active")) {
      iconBlock.style.fill = "#000";
      phoneBtns.style.borderColor = "none";
    } else {
      iconBlock.style.fill = "#fff";
    }

    createBlock.style.backgroundColor = "#FF9800";
    icons.forEach(function (icon) {
      icon.style.fill = "#FF9800";
    });
    BaseHelpers.removeActiveClass(colorPalette);
    orange.classList.add("create__color-btn_active");
  });

  blue.addEventListener("click", function () {
    if (darkTheme.classList.contains("create__btn_active")) {
      iconBlock.style.fill = "#000";
      phoneBtns.style.borderColor = "none";
    } else {
      iconBlock.style.fill = "#fff";
    }

    createBlock.style.backgroundColor = "#0691F2";
    icons.forEach(function (icon) {
      icon.style.fill = "#0691F2";
    });
    BaseHelpers.removeActiveClass(colorPalette);
    blue.classList.add("create__color-btn_active");
  });

  purple.addEventListener("click", function () {
    if (darkTheme.classList.contains("create__btn_active")) {
      iconBlock.style.fill = "#000";
      phoneBtns.style.borderColor = "none";
    } else {
      iconBlock.style.fill = "#fff";
    }

    createBlock.style.backgroundColor = "#A7A1F1";
    icons.forEach(function (icon) {
      icon.style.fill = "#A7A1F1";
    });
    BaseHelpers.removeActiveClass(colorPalette);
    purple.classList.add("create__color-btn_active");
  });

  function changeFeatureForm() {
    let featureSection = document.querySelector('.features-section');
    let sectionTop = featureSection.getBoundingClientRect().bottom;
    let triggerPoint = sectionTop * .1;

    if (IS_SMALL_SIZE) {
      featureSection = document.querySelector('.create__phone');
      sectionTop = featureSection.getBoundingClientRect().top;
      triggerPoint = sectionTop * .9;
    }

    if (sectionTop <= window.innerHeight - triggerPoint) {
      iconBlock.style.fill = "#000";
      phoneBtns.style.borderColor = "none";
      handleDarkTheme();
      createBlock.style.backgroundColor = "#D0CDC0";
        icons.forEach(function (icon) {
          icon.style.fill = "#D0CDC0";
      });

      gray.classList.add("create__color-btn_active");
    } else {
      gray.classList.remove("create__color-btn_active");
      handleLightTheme();
    }
  }

  // Проверка при прокрутке страницы
  window.addEventListener("scroll", changeFeatureForm);
  //Выбор радиуса

  let phoneButtons = document.querySelector(".phone__buttons");
  let phoneBtnActive = document.querySelector(".phone__btn_active");
  let phoneMenuSvg = document.querySelector(".phone__menu-svg");
  let phoneCard = document.querySelector(".phone__card");
  let phoneCard2 = document.querySelector(".phone__card-2");
  let phoneImgs = document.querySelectorAll(".phone__img");
  let customSlider = document.getElementById("customSlider");
  let sliderThumb = document.getElementById("sliderThumb");
  let inputNumberShow = document.getElementById("number");

  let initialVal = 12;
  inputNumberShow.textContent = initialVal;

  let thumbWidth = (initialVal / 20) * 80 + 20;
  sliderThumb.style.width = thumbWidth + "%";

  let isDragging = false;

  sliderThumb.addEventListener("mousedown", startDragging);
  sliderThumb.addEventListener("touchstart", startDragging);

  document.addEventListener("mousemove", drag);
  document.addEventListener("touchmove", drag);

  document.addEventListener("mouseup", stopDragging);
  document.addEventListener("touchend", stopDragging);

  function startDragging(e) {
    e.preventDefault();
    isDragging = true;
  }

  function drag(e) {
    if (isDragging) {
      let newPosition = e.clientX || e.touches[0].clientX;
      let sliderRect = customSlider.getBoundingClientRect();
      let newPositionRelative = newPosition - sliderRect.left;

      newPositionRelative = Math.max(
        0,
        Math.min(sliderRect.width, newPositionRelative)
      );

      let newValue = Math.round((newPositionRelative / sliderRect.width) * 20);
      inputNumberShow.textContent = newValue;

      let newThumbWidth = (newValue / 20) * 80 + 20;
      sliderThumb.style.width = newThumbWidth + "%";

      let radiusValue = (newValue / 20) * 20 + "px";
      setRadii(radiusValue);
    }
  }

  function stopDragging() {
    isDragging = false;
  }

  function setRadii(value) {
    phoneButtons.style.borderRadius = value;
    phoneBtnActive.style.borderRadius = value;
    phoneMenuSvg.style.borderTopLeftRadius = value;
    phoneMenuSvg.style.borderTopRightRadius = value;
    phoneCard.style.borderRadius = value;
    phoneCoins.style.borderRadius = value;
    phoneCard2.style.borderTopLeftRadius = value;
    phoneCard2.style.borderBottomLeftRadius = value;

    phoneCard3.forEach(function (card3) {
      card3.style.borderRadius = value;
    });
    phoneImgs.forEach(function (img) {
      img.style.borderRadius = value;
    });
  }

  const tabTitles = document.querySelectorAll(".loyalty-section__tab-nav-btn");
  const tabContents = document.querySelectorAll(".loyalty-section__tab-picture");
  const tabTextContents = document.querySelectorAll(".loyalty-section__tab-content-item");

  tabTitles.forEach((title) => {
    title.addEventListener("click", () => {
      // Remove active class from all titles and hide all images and text contents
      tabTitles.forEach((item) => item.classList.remove("active-tab"));
      tabContents.forEach((content) =>
        content.classList.remove("loyalty-section__tab-picture-active") // Reset active class
      );
      tabContents.forEach((content) =>
        content.classList.add("hidden-tab") // Hide all images
      );

      tabTextContents.forEach((textContent) => textContent.classList.add("hidden-tab")); // Hide all text content

      // Get the specific image and text content associated with the clicked button
      const content = document.querySelector("#" + title.dataset.tab);
      const textContent = document.querySelector(
          ".loyalty-section__tab-content-item[data-tab=" + title.dataset.tab + "]"
      );

      // Show the selected image and text content
      content.classList.remove("hidden-tab");
      textContent.classList.remove("hidden-tab");

      // Add active class to the clicked button
      title.classList.add("active-tab");

      // Add animation class to the displayed image after a short delay
      setTimeout(() => {
        content.classList.add("loyalty-section__tab-picture-active");
      }, 10);
    });
  });

  /** Parallax images elements */
  const images = document.querySelectorAll(".thumbnail-img");
  const imagesMobile = document.querySelectorAll(".thumbnail-mobile");
  const image = document.querySelectorAll(".thumbnail");
  const imageLoyalt = document.querySelectorAll(".thumbnail-loyalt");

  BaseHelpers.handleParallax(imageLoyalt, 1.1);
  BaseHelpers.handleParallax(image, parallaxScaleSize);
  BaseHelpers.handleParallax(imagesMobile, parallaxScaleSize);
  BaseHelpers.handleParallax(images, parallaxScaleSize);

  const progressBg = document.querySelector(".promo-section__progress-bg");
  const progressCurrent = document.querySelector(".progress-current");
  const promoSection = document.querySelector(".promo-section__row-list");

  function handleScroll() {
    const promoSectionRect = promoSection.getBoundingClientRect();

    if (
      promoSectionRect.top <= window.innerHeight &&
      promoSectionRect.bottom >= 0
    ) {
      BaseHelpers.increaseProgressBar(progressBg, progressCurrent);

      window.removeEventListener("scroll", handleScroll);
    }
  }

  window.addEventListener("scroll", handleScroll);

  handleScroll();

  const cards = document.querySelectorAll(".delivery-section__col-slide");
  let lastIndex = -1;

  // Создаем наблюдатель
  const deliveryObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const index = Array.from(cards).indexOf(entry.target);
      const progressBlocks = document.querySelectorAll(
          ".delivery-section__progress-bar"
      );

      if (entry.isIntersecting) {
        if (index > lastIndex) {
          progressBlocks[index].style.width = "100%";
          BaseHelpers.showCardsSequentially(index, lastIndex, cards);
          lastIndex = index;
        }
      } else {
        if (index < lastIndex) {
          BaseHelpers.hideCardsSequentially(index, lastIndex, cards);
          lastIndex = index - 1;
        }
      }
    });
  }, { threshold: 0.5 });

  function switchObserver() {
    deliveryObserver.disconnect();
    if (IS_TABLET || IS_PC || IS_LARGE_PC) {
      cards.forEach((card) => deliveryObserver.observe(card));
    }
  }

  switchObserver();

  if (window.matchMedia("(max-width: 1024px)").matches) {
    const deliverySwiper = new Swiper(".deliverySwiper", {
      modules: [Parallax, Autoplay, FreeMode],
      spaceBetween: 30,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      longSwipes: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: false,
      },
      on: {
        autoplayTimeLeft(swiper, time, progress) {
          // Reset all progress bars before filling the current one
          document.querySelectorAll(".delivery-section__progress-bars").forEach((bar) => {
            bar.style.width = "0%";
          });

          // Find the active slide by checking swiper.slides
          const activeSlide = Array.from(swiper.slides).find(slide => slide.classList.contains('swiper-slide-active'));

          if (activeSlide) {
            // Find the progress bar in the active slide
            const progressBlock = activeSlide.querySelectorAll(".delivery-section__progress-block");
            if (progressBlock) {
              const progressBar = progressBlock[swiper.realIndex].querySelector(".delivery-section__progress-bars");
              if (progressBar) {
                // Fill the progress bar for the active slide
                progressBar.style.width = `${(1 - progress) * 100}%`;
              }
            }
          }
        },
      },
    });

    // Добавляем обработчики для смены слайда при клике на изображение
    document.querySelectorAll(".delivery-img").forEach((slide) => {
      slide.addEventListener("click", (event) => {
        const slideRect = slide.getBoundingClientRect();
        const clickX = event.clientX - slideRect.left;

        if (clickX < slideRect.width / 2) {
          deliverySwiper.slidePrev();
        } else {
          deliverySwiper.slideNext();
        }
      });
    });
  }

  let clientsSection = document.querySelector(".clients-section__list");

  function checkScroll() {
    let scrollPosition = window.scrollY;
    let sectionPosition = clientsSection.offsetTop;
    let windowHeight = window.innerHeight;

    if (scrollPosition + windowHeight >= sectionPosition) {
      clientsSection.classList.add("scroll-animation");
    } else {
      clientsSection.classList.remove("scroll-animation");
    }
  }

  function checkPromoSectionScroll() {
    const promo = document.querySelectorAll('.promo-section__checkbox');
    const promoSection = document.querySelector('.promo-section');
    const action = document.querySelectorAll('.promo-section__action-input');
    const sectionTop = promoSection.getBoundingClientRect().top;
    const sectionHeight = promoSection.offsetHeight;
    let triggerPoint = sectionHeight * 0.8;

    if (sectionTop <= window.innerHeight - triggerPoint) {
      if (!promo[0].checked && !action[2].checked) {
        setTimeout(() => {
          action[2].checked = true;
        }, IS_SMALL_SIZE ? 400 : 1000);
        promo[0].checked = true;
      }
    } else {
      if (promo[0].checked && action[2].checked) {
        action[2].checked = false;
        promo[0].checked = false;
      }
    }
  }

  // Проверка при загрузке страницы
  checkPromoSectionScroll();

  // Проверка при прокрутке страницы
  window.addEventListener("scroll", checkPromoSectionScroll);

  function checkNewsLetterScroll() {
    const newsLetter = document.querySelector('.newsletters-section');
    const switcher = document.querySelector('.newsletters-section__switcher-trigger');
    const sectionTop = newsLetter.getBoundingClientRect().top;
    const sectionHeight = newsLetter.offsetHeight;

    let triggerPoint = sectionHeight * 0.5;

    if (IS_SMALL_SIZE) {
      triggerPoint = sectionHeight * 0.99;
    } else if (IS_TABLET) {
      triggerPoint = sectionHeight * 0.6;
    } else if (IS_PC) {
      triggerPoint = sectionHeight * 0.8;
    }

    if (sectionTop <= window.innerHeight - triggerPoint) {
      if (!switcher.checked) {
        switcher.checked = true;
      }
    } else {
      if (switcher.checked) {
        switcher.checked = false;
      }
    }
  }

  // Проверка при загрузке страницы
  checkNewsLetterScroll();

  // Проверка при прокрутке страницы
  window.addEventListener("scroll", checkNewsLetterScroll);

  // Проверка при загрузке страницы
  checkScroll();

  // Проверка при прокрутке страницы
  window.addEventListener("scroll", checkScroll);

  const swiperBrands = new Swiper(".clients-section__list", {
    modules: [Parallax, Autoplay, FreeMode],
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    speed: 2000,
    effect: "slide",
    loopedSlides: 9,
    mousewheel: false,
    freeMode: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },

    breakpoints: {
      320: {
        slidesPerView: 1.3,
      },
      425: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 5,
      },
      2560: {
        slidesPerView: 6,
      },
    },
  });

  const sliderBrandContainer = document.querySelector(
      ".clients-section__list"
  );

  sliderBrandContainer.addEventListener("mouseenter",  () => {
    swiperBrands.autoplay.stop();
  });

  sliderBrandContainer.addEventListener("mouseleave", function () {
    swiperBrands.autoplay.start();
  });

  sliderBrandContainer.addEventListener("touchstart", function () {
    swiperBrands.autoplay.stop();
  });

  sliderBrandContainer.addEventListener("touchend", function () {
    swiperBrands.autoplay.start();
  });

  const swiperAdmin = new Swiper(".admin-panel__slider", {
    modules: [Parallax, Autoplay, FreeMode],
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    speed: 2000,
    effect: "slide",
    loopedSlides: 7,
    mousewheel: false,
    freeMode: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },

    breakpoints: {
      320: {
        slidesPerView: 1.5,
      },
      425: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 5,
      },
      2560: {
        slidesPerView: 8,
      },
    },
  });

  const sliderContainer = document.querySelector(
      ".admin-panel-section__slider"
  );

  sliderContainer.addEventListener("mouseenter", function () {
    swiperAdmin.autoplay.stop();
  });

  sliderContainer.addEventListener("mouseleave", function () {
    swiperAdmin.autoplay.start();
  });

  sliderContainer.addEventListener("touchstart", function () {
    swiperAdmin.autoplay.stop();
  });

  sliderContainer.addEventListener("touchend", function () {
    swiperAdmin.autoplay.start();
  });

  // TODO оптимизировать форму
  document
    .getElementById("myForm")
    .addEventListener("submit", function (event) {
      event.preventDefault();

      const nameInput = document.querySelector('[name="cta_name"]');
      const phoneInput = document.querySelector('[name="cta_phone"]');
      const brandInput = document.querySelector('[name="cta_brand"]');
      const nameError = document.getElementById("nameError");
      const phoneError = document.getElementById("phoneError");
      const brandError = document.getElementById("brandError");

      // Reset errors
      nameInput.classList.remove("u-input--status-error");
      phoneInput.classList.remove("u-input--status-error");
      brandInput.classList.remove("u-input--status-error");
      nameError.textContent = "";
      phoneError.textContent = "";
      brandError.textContent = "";

      let isValid = true;

      if (!nameInput.value.trim()) {
        nameInput.classList.add("u-input--status-error");
        nameError.textContent = "Заполните поле";
        isValid = false;
      } else {
        const namePattern = /^[А-Яа-яЁё\s]+$/;
        if (!namePattern.test(nameInput.value)) {
          nameInput.classList.add("u-input--status-error");
          nameError.textContent =
            "Имя не должно содержать латинские буквы, цифр и символов";
          isValid = false;
        }
      }

      if (!phoneInput.value.trim()) {
        phoneInput.classList.add("u-input--status-error");
        phoneError.textContent = "Заполните поле";
        isValid = false;
      } else {
        if (phoneInput.value.replace(/[^0-9]/g, "").length < 11) {
          phoneInput.classList.add("u-input--status-error");
          phoneError.textContent =
            "Номер телефона должен содержать не менее 11 цифр";
          isValid = false;
        }
      }

      // Check if the brand is empty
      if (!brandInput.value.trim()) {
        brandInput.classList.add("u-input--status-error");
        brandError.textContent = "Заполните поле";
        isValid = false;
      }

      if (isValid) {
        // Если все поля прошли валидацию, отправляем данные на сервер
        const name = encodeURIComponent(nameInput.value);
        const phone = encodeURIComponent(phoneInput.value);
        const brand = encodeURIComponent(brandInput.value);

        const url = `https://demo.cyberiasoft.com/LoyaltyService/api/feedback/form?Type=0&Name=${name}&Phone=${phone}&Brend=${brand}`;

        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            console.log("Успешно отправлено!");

            // Очистка полей формы
            nameInput.value = "";
            phoneInput.value = "";
            brandInput.value = "";

            // Перенаправление на страницу благодарности
            window.location.href = "../thanks.html";
          })
          .catch((error) => {
            console.error(error)
            console.error("Ошибка отправки запроса:", error.message);
          });
      }
    });

  function updateBlocks() {
    const nameInput = document.getElementById("nameInput");
    const textArea = document.getElementById("textArea");
    const output = document.getElementById("output");

    let name =
      nameInput.value.trim() || localStorage.getItem("userName") || "Дима";
    let text = textArea.value.trim();

    text = text.replace(/Дима/g, name);

    output.textContent = `${name}, ${text}`;
  }

  function saveUserName() {
    const nameInput = document.getElementById("nameInput");
    localStorage.setItem("userName", nameInput.value.trim());
  }

  document.getElementById("textArea").addEventListener("input", updateBlocks);
  document.getElementById("nameInput").addEventListener("input", updateBlocks);
  document.getElementById("myForm").addEventListener("submit", saveUserName);

  updateBlocks();

  if (!IS_TABLET) {
    gsap
      .timeline()
      .fromTo(
        ".info-section__suptitle",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".features-section",
            start: "bottom 60%",
            end: "bottom 20%",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".info-section__title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".features-section",
            start: "bottom 40%",
            end: "bottom 10%",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".loyalty-section__col-title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".loyalty-section",
            start: "top 30%",
            end: "30% center",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".loyalty-section__subtitle",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".loyalty-section",
            start: "top 30%",
            end: "40% center",
            scrub: true,
          },
        }
      );

    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".hero-section__btn",
          scrub: true,
          start: "bottom 30%",
          end: "bottom -90%",
        },
      })
      .to(".js-parallax-hero-picture", {
        y: 130,
        duration: 1,
        ease: "none",
      })
      .fromTo(
        ".promo-section__title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".promo-section__row-content",
            start: "top bottom",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".promo-section__col-content",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".promo-section__row-content",
            start: "top bottom",
            end: '40% bottom',
            scrub: true,
          },
        }
      )
      .fromTo(
        ".newsletters-section__title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".newsletters-section__col-media",
            start: "20% center",
            end: "bottom bottom",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".newsletters-section__text",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".newsletters-section__col-media",
            start: "40% center",
            end: "bottom bottom",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".delivery-section__title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".delivery-section__row-content",
            start: "top bottom",
            end: "bottom 50%",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".delivery-section__text",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".delivery-section__row-content",
            start: "top bottom",
            end: "bottom 50%",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".integrations-section__text",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".integrations-section__title",
            start: "top bottom",
            end: "center bottom",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".integrations-section__title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".integrations-section__col-title",
            start: "30% bottom",
            end: "bottom bottom",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".admin-panel-section__title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".admin-panel-section__container",
            start: "bottom 100%",
            end: "bottom 80%",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".admin-panel-section__text-1",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".admin-panel-section__container",
            start: "bottom 85%",
            end: "bottom 65%",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".clients-section__title",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".clients-section__list",
            start: "top bottom",
            end: "center bottom",
            scrub: true,
          },
        }
      )
      .fromTo(
        ".clients-section__text",
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".clients-section__list",
            start: "center bottom",
            end: "bottom bottom",
            scrub: true,
          },
        }
      );
  }

const words = document.querySelectorAll(
  ".features-section__title-line > div > span"
);

window.addEventListener("scroll", () => {
  const t =
    window.scrollY /
    (document.documentElement.scrollHeight - window.innerHeight);
  words.forEach((word, index) => {
    word.style.backgroundPosition = `${-t * 100 * (index + 1)}% 0`;
  });
});

const tl = gsap.timeline();

// Массив букв "аутсорс"
const imagesGsap = document.querySelectorAll(".hero-section__col-image");

// Запуск появления элементов .header
tl.from(imagesGsap, {
  y: 400,
  stagger: 0.12,
  duration: 0.5,
  ease: "power2.out",
  onComplete: function () {
    imagesGsap.forEach((img) => (img.style.display = "block"));
  },
})
  .fromTo(
    ".hero-section__img-container",
    {
      opacity: 0,
      scale: 1.2,
      x: 150,
      y: 150,
    },
    {
      opacity: 1,
      scale: 1,
      x: 0,
      y: 0,
      duration: 1.2,
    },
    0.1
  )
  .fromTo(
    ".hero-section__subtitle",
    {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.75,
    },
    '<+=0.7'
  )
  .fromTo(
    ".hero-section__text-item",
    {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.75,
    },
    '<+=0.2'
  )
  .fromTo(
    ".hero-section__btn",
    {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.5,
    },
    '<+=0.2'
  )
  .fromTo(
    ".header",
    {
      opacity: 0.01,
    },
    {
      opacity: 1,
    },
    '<+=0'
  );

gsap.utils.toArray(".js-parallax-img").forEach(function (container) {
  let image = container.querySelector("img");

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      scrub: true,
      pin: false,
      markers: false,
    },
  });
  tl.to(image, {
    y: 80,
    ease: "none",
  });
});
